/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-07-10 14:06:47
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-07-14 10:34:43
 * @FilePath: /intl-pc-jdi-website-ssr/src/utils/eventTrack/eventTrackingHistory.ts
 * @Description: 前置跳转、点击的历史记录，用于在埋点公参上报，做流量来源归因
 */
import cookieUtil from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { logger } from '@/utils/logger';

const CLICK_HISTORY_KEY = 'clickEvent';

export type Click_Event_Type = {
  curClickEvent: string;
  curPageId: string;
  curClickParam: any;
};

export function fetchClickHistory(): Click_Event_Type[] {
  const sessionVal = cookieUtil.getSessionStorage(CLICK_HISTORY_KEY);

  if (sessionVal) {
    try {
      const clickData: Click_Event_Type[] = JSON.parse(sessionVal);
      if (Array.isArray(clickData)) {
        return clickData;
      }
    } catch (error) {
      logger.error({
        eventName: 'fetch_click_history_error',
        error,
      });
      return [];
    }
  }
  return [];
}

export function appendClickHistory(event: Click_Event_Type) {
  const list = fetchClickHistory();

  // 页面发生跳转时，记录点击历史
  // curPageId不同则添加
  if (list.length === 0 || list[0].curPageId !== event.curPageId) {
    list.unshift(event);
  } else if (list[0]?.curPageId === event.curPageId) {
    // 页面未发生跳转，覆盖原点击记录
    list[0] = event;
  }

  while (list.length > 5) {
    list.pop(); // 移除最后的记录
  }

  cookieUtil.setSessionStorage(CLICK_HISTORY_KEY, JSON.stringify(list));
}

export function fetchSessionPageHistory() {
  const PAGE_HISTORY_KEY = 'pageHistory';
  const sessionVal = cookieUtil.getSessionStorage(PAGE_HISTORY_KEY);

  if (sessionVal) {
    try {
      const historyList: string[] = JSON.parse(sessionVal);
      if (Array.isArray(historyList)) {
        return historyList;
      }
    } catch (error) {
      logger.error({
        eventName: 'fetch_session_page_history_error',
        error,
      });
      return [];
    }
  }
  return [];
}
